import { render } from "./WeightBarbell.vue?vue&type=template&id=10815a77&scoped=true"
import script from "./WeightBarbell.vue?vue&type=script&lang=js"
export * from "./WeightBarbell.vue?vue&type=script&lang=js"

import "./WeightBarbell.vue?vue&type=style&index=0&id=10815a77&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10815a77"]])

export default __exports__